import './Typing.css';

const Typing = () => {
    return (
        <div className="message_row fr">
            <div className="message_row__content uslm">
                <div className="typing__dot"></div>
                <div className="typing__dot"></div>
                <div className="typing__dot"></div>
            </div>
        </div>
    )
}

export default Typing;